import React from "react";
import "./InformationSection.css";

// 이미지 경로
import titleImage from "../assets/extra/13.jpg";
import image01 from "../assets/extra/1.png";
import image02 from "../assets/extra/2.png";
import image03 from "../assets/extra/3.png";
import image04 from "../assets/extra/4.png";

function InformationSection() {
    return (
        <section className="information-section">
            {/* 제목 이미지 */}
            <div className="information-title">
                <img src={titleImage} alt="채움기획 정보" />
            </div>

            {/* 콘텐츠 이미지 */}
            <div className="information-content">
                <div className="information-item">
                    <img src={image01} alt="01 불법적인 어뷰징 NO" />
                </div>
                <div className="information-item">
                    <img src={image02} alt="02 재방문 고객 만들기" />
                </div>
                <div className="information-item">
                    <img src={image03} alt="03 리얼리뷰" />
                </div>
                <div className="information-item">
                    <img src={image04} alt="04 채움기획의 마인드" />
                </div>
            </div>
        </section>
    );
}

export default InformationSection;
